import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CardInfoActions, CardInfoFacade } from './+state';

@NgModule( {
    declarations: [],
    imports: [
        CommonModule
    ],
    providers: [ CardInfoActions, CardInfoFacade ]
} )
export class CardInfoModule { }
